import { render, staticRenderFns } from "./new-contact.vue?vue&type=template&id=d91aaaa6&scoped=true&"
import script from "./new-contact.ts?vue&type=script&lang=ts&"
export * from "./new-contact.ts?vue&type=script&lang=ts&"
import style0 from "./new-contact.scss?vue&type=style&index=0&id=d91aaaa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91aaaa6",
  null
  
)

export default component.exports